import React from 'react'

import { VIBE } from 'constants/socket'
import { throttle } from 'helpers/lodash'
import { dispatchSendSocketMessage } from 'store/dispatcher'

import { Btn, Container } from './styles'

export const getVibeMsg = (sender, reciever) => ({
    action: VIBE,
    sender,
    reciever,
})

const VibeBtn = ({ id, uuid, localUserId, disabled, teacher }) => {
    const onVibeClick = React.useCallback(
        throttle(() => {
            const msg = getVibeMsg(localUserId, uuid)
            dispatchSendSocketMessage(msg)
        }, 3000),
        []
    )

    const props = {
        disabled,
        teacher,
        className: 'vibe-btn',
        id,
        onClick: onVibeClick,
    }

    return (
        <Container {...props}>
            <Btn src="/assets/revamp/shaka.svg" height="60%" width="60%" />
        </Container>
    )
}

export default VibeBtn
